import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { Box, Container } from '@mui/material';

import { SiteAuthHeader } from './components/AuthHeader';

import * as Screens from "./screens";
import { SiteFooter } from "../components/AppFooter";

export function SiteAuth() {
	return (
		<>
			<Routes>
				<Route path="" element={<Screens.AuthRoot/>} />
				<Route path="login" element={<Screens.AuthLogin/>} />
				<Route path="register" element={<Screens.AuthRegister/>} />
				<Route path="password/forgot" element={<Screens.AuthForgotPassword/>} />
				<Route path="password/setup/:token" element={<Screens.AuthSetupPassword />} />
				<Route path="email/verify" index={false} element={<Screens.AuthVerifyEmail />} />
				<Route path="email/verify/:token" element={<Screens.AuthVerifyEmailFinal />} />
			</Routes>
			<Box mt='auto'>
				<SiteFooter />
			</Box>
		</>
	);
}
